import { BaseController } from '../../common/base/controller';

export class ForgotPasswordController extends BaseController {
  constructor(controllerService, loginService, $scope, $stateParams) {
    'ngInject';
    super({ controllerService, loginService, $scope });
  }

  $onInit() {}

  submit() {
    this.isSubmitBusy = true;
    const { userName } = this;
    this.loginService
      .sendPasswordResetMail(userName)
      .then(this.success.bind(this))
      .catch(this.handleError.bind(this))
      .finally(() => {
        this.isSubmitBusy = false;
      });
  }

  success(resp) {
    delete this.errorMessage;
    this.successMessage = 'app.forgot.password.success';
  }

  handleError(response) {
    switch (response.status) {
      case 404: {
        this.errorMessage = 'app.forgot.password.error.404';
        break;
      }
      case 500:
      default: {
        this.errorMessage = 'app.error.unknown';
        break;
      }
    }
  }
}
